import { PrivateModeBackupReminder } from "rujira.ui";
import { useRedactedV2 } from "../../redacted/v2";
import { useAccounts } from "../../services/accounts";
import { useRedacted } from "../../services/redacted";

export const PrivateBackupReminder = () => {
  const session = useRedactedV2();
  const { selected } = useAccounts();
  const { isPrivateMode } = useRedacted();
  const pendingOperation = ["preparing", "submitting", "pending"].includes(
    session.operation?.phase ?? ""
  );
  return (
    <PrivateModeBackupReminder
      controls={session}
      scope={session.proxyContract ?? ""}
      available={
        session.enabled && !!selected && isPrivateMode && !pendingOperation
      }
    />
  );
};
